import { createListFilters, IOption } from '../../../../../components'
import { SituacaoInterconsulta } from '../../../../../../_metronic/helpers'

export type PareceresFilters = {
  paciente: string
  protocolo: string
  /** Situação do ponto de vista do solicitante; várias combinadas com "ou". */
  situacoes: IOption<SituacaoInterconsulta>[]
  empresa?: IOption<number>
  /** Período: campo de data ("Consultas entre") + início/fim (aaaa-mm-dd), máx. 31 dias. */
  range?: IOption<string>
  dataInicial: string
  dataFinal: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<PareceresFilters>({
  paciente: '',
  protocolo: '',
  situacoes: [],
  empresa: undefined,
  range: undefined,
  dataInicial: '',
  dataFinal: '',
})
